import { api, API_ENDPOINTS } from '../lib/api';

// Extend API_ENDPOINTS (used locally, endpoints added to api.ts below)
const NOTIFICATION_ENDPOINTS = {
  BASE: '/notifications',
  DEVICES: '/notifications/devices',
  UNREAD_COUNT: '/notifications/unread-count',
  READ_ALL: '/notifications/read-all',
  MARK_READ: (id: string) => `/notifications/${id}/read`,
  UNREGISTER_DEVICE: (token: string) => `/notifications/devices/${encodeURIComponent(token)}`,
};

export interface Notification {
  id: string;
  userId: string;
  type: string;
  title: string;
  body: string;
  data: Record<string, string> | null;
  isRead: boolean;
  readAt: string | null;
  sentVia: string;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedNotifications {
  data: Notification[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  hasNextPage: boolean;
}

export interface RegisterDevicePayload {
  fcmToken: string;
  platform?: string;
  deviceInfo?: Record<string, any>;
}

export const notificationService = {
  // Device token management
  registerDevice: async (payload: RegisterDevicePayload): Promise<void> => {
    await api.post(NOTIFICATION_ENDPOINTS.DEVICES, payload);
  },

  unregisterDevice: async (token: string): Promise<void> => {
    await api.delete(NOTIFICATION_ENDPOINTS.UNREGISTER_DEVICE(token));
  },

  // Notifications
  getNotifications: async (page = 1, limit = 20): Promise<PaginatedNotifications> => {
    const response = await api.get<PaginatedNotifications>(NOTIFICATION_ENDPOINTS.BASE, {
      params: { page, limit },
    });
    return response.data;
  },

  getUnreadCount: async (): Promise<number> => {
    const response = await api.get<{ unreadCount: number }>(NOTIFICATION_ENDPOINTS.UNREAD_COUNT);
    return response.data.unreadCount;
  },

  markAsRead: async (notificationId: string): Promise<void> => {
    await api.patch(NOTIFICATION_ENDPOINTS.MARK_READ(notificationId));
  },

  markAllAsRead: async (): Promise<void> => {
    await api.patch(NOTIFICATION_ENDPOINTS.READ_ALL);
  },
};
